"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTemperatureJson = exports.Temperature = exports.TemperatureUnitTexts = exports.TemperatureUnits = void 0;
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var TemperatureUnits;
(function (TemperatureUnits) {
    TemperatureUnits["default"] = "\u00B0C";
    TemperatureUnits["celsius"] = "\u00B0C";
    TemperatureUnits["fahrenheit"] = "\u00B0F";
    TemperatureUnits["kelvin"] = "K";
})(TemperatureUnits = exports.TemperatureUnits || (exports.TemperatureUnits = {}));
exports.TemperatureUnitTexts = {
    [TemperatureUnits.default]: '°C',
    [TemperatureUnits.celsius]: '°C',
    [TemperatureUnits.fahrenheit]: '°F',
    [TemperatureUnits.kelvin]: 'K',
};
class Temperature extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'Temperature';
        this.type = this.className;
        this.defaultUnit = 'celsius';
        this.unitTexts = exports.TemperatureUnitTexts;
    }
    static getUnitText(unit) {
        return exports.TemperatureUnitTexts[unit];
    }
    static fromJson(q) {
        if (!(0, echain_shared_ts_utils_1.isValueInEnum)(TemperatureUnits, q.Unit)) {
            throw new Error(`Temperature.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new Temperature(q);
    }
    static celsius(v) {
        return new Temperature(v, TemperatureUnits.celsius);
    }
    static fahrenheit(v) {
        return new Temperature(v, TemperatureUnits.fahrenheit);
    }
    static kelvin(v) {
        return new Temperature(v, TemperatureUnits.kelvin);
    }
    fahrenheitToCelsius(value) {
        return (value - 32) / 1.8;
    }
    celsiusToFahrenheit(value) {
        return value * 1.8 + 32;
    }
    kelvinToCelsius(value) {
        return value - Temperature.kelvinFreezePoint;
    }
    celsiusToKelvin(value) {
        return value + Temperature.kelvinFreezePoint;
    }
    // getters
    set celsius(v) {
        this.value = v;
        this.unit = TemperatureUnits.celsius;
    }
    get celsius() {
        switch (this.unit) {
            case TemperatureUnits.fahrenheit:
                return this.fahrenheitToCelsius(this.value);
            case TemperatureUnits.kelvin:
                return this.kelvinToCelsius(this.value);
            case TemperatureUnits.celsius:
                return this.value;
            default:
                throw new Error(`${this.className}.celsius: Unit not supported`);
        }
    }
    set fahrenheit(v) {
        this.value = v;
        this.unit = TemperatureUnits.fahrenheit;
    }
    get fahrenheit() {
        switch (this.unit) {
            case TemperatureUnits.celsius:
                return this.celsiusToFahrenheit(this.value);
            case TemperatureUnits.kelvin:
                return this.celsiusToFahrenheit(this.kelvinToCelsius(this.value));
            case TemperatureUnits.fahrenheit:
                return this.value;
            default:
                throw new Error(`${this.className}.fahrenheit: Unit not supported`);
        }
    }
    set kelvin(v) {
        this.value = v;
        this.unit = TemperatureUnits.kelvin;
    }
    get kelvin() {
        switch (this.unit) {
            case TemperatureUnits.celsius:
                return this.celsiusToKelvin(this.value);
            case TemperatureUnits.fahrenheit:
                return this.celsiusToKelvin(this.fahrenheitToCelsius(this.value));
            case TemperatureUnits.kelvin:
                return this.value;
            default:
                throw new Error(`${this.className}.kelvin: Unit not supported`);
        }
    }
    clone() {
        return Temperature.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case TemperatureUnits.celsius:
                return this.celsius;
            case TemperatureUnits.kelvin:
                return this.kelvin;
            case TemperatureUnits.fahrenheit:
                return this.fahrenheit;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
    }
}
exports.Temperature = Temperature;
Temperature.units = TemperatureUnits;
Temperature.kelvinFreezePoint = 273.15;
const isTemperatureJson = (l) => {
    return (0, Quantity_1.isQuantityJson)(l) && (0, echain_shared_ts_utils_1.isValueInEnum)(TemperatureUnits, l.Unit);
};
exports.isTemperatureJson = isTemperatureJson;
//# sourceMappingURL=Temperature.js.map